import { marketplaceSearchQuery } from "@/lib/scan/marketplaceSearchQuery";

/** ALT sold searches require sign-in and use a combined grader/grade facet. */
export function altSoldsSearch(
  { graded, gradingCompany, grade, ...card }: Parameters<typeof marketplaceSearchQuery>[0] & {
    graded: boolean;
    gradingCompany?: string | null;
    grade?: string | null;
  },
) {
  const company = gradingCompany?.trim().toUpperCase();
  const grader = company === "BECKETT" ? "BGS" : company;
  const score = grade?.trim();
  if (
    !card.name.trim() || !graded || !grader || !["PSA", "BGS", "SGC", "CGC"].includes(grader)
    || !score || !/^(?:[1-9](?:\.0|\.5)?|10(?:\.0)?)$/.test(score)
  ) return null;
  const gradeKey = `${grader}-${Number(score)}`;
  const query = marketplaceSearchQuery(card);
  const params = new URLSearchParams({
    gradeKey,
    query,
    soldListings: "true",
    sortBy: "newest_first",
  });
  return {
    marketplace: "ALT" as const,
    name: card.name,
    query,
    gradingService: grader,
    grade: String(Number(score)),
    url: `https://alt.xyz/browse?${params.toString()}`,
    hint: `${grader} ${Number(score)} · Login required`,
  };
}

export type AltSoldsSearch = NonNullable<ReturnType<typeof altSoldsSearch>>;
